import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from "reactstrap";
import moment from "moment/moment";

const DetailInfoModal = ({ isOpen, onClose, detailData }) => {
  const val = (v) => (v == null || v === "" ? "-" : v);

  const renderSection = (title, icon, rows) => (
    <React.Fragment key={title}>
      <h6 className="text-primary mb-2"><i className={`fas ${icon} me-2`}></i>{title}</h6>
      <Table size="sm" bordered responsive className="align-middle mb-4">
        <tbody>
          {rows.map(([label, value], i) => (
            <tr key={i}>
              <td className="text-muted label-cell">{label}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </React.Fragment>
  );

  if (!detailData) {
    return (
      <Modal isOpen={isOpen} toggle={onClose}>
        <ModalHeader toggle={onClose}>Detail Data</ModalHeader>
        <ModalBody>Data tidak tersedia</ModalBody>
        <ModalFooter><Button color="secondary" onClick={onClose}>Tutup</Button></ModalFooter>
      </Modal>
    );
  }

  const b = detailData.bantuan || (Array.isArray(detailData.Bantuans) ? detailData.Bantuans[0] : null);
  const fmt = (n) => (n == null ? "-" : new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n));
  const bantuanRows = !detailData._loadingBantuan && b
    ? [
        ["ID Bantuan", `#${b.id}`],
        ["Jenis / Kategori Bantuan", b.JenisBantuan || "-"],
        ["Anggaran / Nominal", fmt(b.nominal)],
        ["Tanggal Mulai Bantuan", b.tanggalBantuan ? moment(b.tanggalBantuan).format("DD/MM/YYYY") : "-"],
        ["Tanggal Selesai", b.tanggalSelesai ? moment(b.tanggalSelesai).format("DD/MM/YYYY") : "-"],
        ["Status Proses", b.ProsesBantuan?.statusProses || "-"],
        ["Progress", b.Presentase?.presentase != null ? `${b.Presentase.presentase}%` : "-"],
        ["Status Kontrak", b.statusKontrak || "-"],
      ]
    : [];

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" style={{ maxWidth: "900px" }}>
      <ModalHeader toggle={onClose}>Detail Data</ModalHeader>
      <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
        {renderSection("Data Pribadi & Identitas", "fa-user", [
          ["Status Rumah", val(detailData.statusrumah)],
          ["Nomor Blok", val(detailData?.nomorUrut)],
          ["Nomor Rumah Pada Peta", val(detailData.nomorRumahPadaPeta)],
          ["Nama Lengkap KK", val(detailData.namaLengkapKK)],
          ["Usia", detailData.usia != null && detailData.usia !== "" ? `${detailData.usia} Tahun` : "-"],
          ["Tanggal Lahir", detailData.tanggallahir ? moment(detailData.tanggallahir).format("DD/MM/YYYY") : "-"],
          ["Jenis Kelamin", val(detailData.jenisKelamin)],
          ["Nomor KK", val(detailData.nomorKK)],
          ["Nomor KTP", val(detailData.nomorKTP)],
          ["Asal KTP", val(detailData.asalKTP)],
          ["Jumlah KK", val(detailData.jumlahKK)],
          ["Jumlah Penghuni", val(detailData.jumlahPenghuni)],
        ])}

        {renderSection("Alamat & Lokasi", "fa-map-marker-alt", [
          ["Alamat Rumah", val(detailData.alamatRumah)],
          ["Kecamatan", val(detailData.kecamatan)],
          ["Desa/Kelurahan", val(detailData.desaKelurahan)],
          ["Titik Koordinat Rumah", val(detailData.titikKoordinatRumah)],
          ["Manual Titik Koordinat Rumah", val(detailData.manualTitikKoordinatRumah)],
        ])}

        {renderSection("Sosial Ekonomi", "fa-briefcase", [
          ["Pendidikan Terakhir", val(detailData.pendidikanTerakhir)],
          ["Pekerjaan", val(detailData.pekerjaan)],
          ["Fungsi Bangunan", val(detailData.fungsiBangunan)],
          ["Penghasilan", val(detailData.penghasilan)],
          ["Sumber Penerangan", val(detailData.sumberPenerangan)],
          ["Daya Listrik", val(detailData.dayaListrik)],
          ["Bantuan Perumahan", val(detailData.bantuanPerumahan)],
        ])}

        {renderSection("Kepemilikan", "fa-home", [
          ["Status Kepemilikan Rumah", val(detailData.statusKepemilikanRumah)],
          ["Aset Rumah di Tempat Lain", val(detailData.asetRumahDiTempatLain)],
          ["Status Kepemilikan Tanah", val(detailData.statusKepemilikanTanah)],
          ["Aset Tanah di Tempat Lain", val(detailData.asetTanahDiTempatLain)],
        ])}

        {renderSection("Konstruksi Bangunan", "fa-building", [
          ["Jenis Rumah", val(detailData.modelRumah)],
          ["Pondasi", val(detailData.pondasi)],
          ["Kolom", val(detailData.kolom)],
          ["Rangka Atap", val(detailData.rangkaAtap)],
          ["Plafon", val(detailData.plafon)],
          ["Balok", val(detailData.balok)],
          ["Sloof", val(detailData.sloof)],
          ["Pintu/Jendela/Konsen", val(detailData.pintuJendelaKonsen)],
          ["Ventilasi", val(detailData.ventilasi)],
        ])}

        {renderSection("Material & Kondisi", "fa-tools", [
          ["Material Lantai Terluas", val(detailData.materialLantaiTerluas)],
          ["Kondisi Lantai", val(detailData.kondisiLantai)],
          ["Material Dinding Terluas", val(detailData.materialDindingTerluas)],
          ["Kondisi Dinding", val(detailData.kondisiDinding)],
          ["Material Penutup Atap Terluas", val(detailData.materialPenutupAtapTerluas)],
          ["Kondisi Penutup Atap", val(detailData.kondisiPenutupAtap)],
          ["Luas Rumah", val(detailData.luasRumah)],
          ["Luas Tanah", val(detailData.luasTanah)],
        ])}

        {renderSection("Sanitasi & Limbah", "fa-toilet", [
          ["Buangan Air Limbah Rumah Tangga", val(detailData.buanganAirLimbahRumahTangga)],
          ["Sarana Pengelolaan Limbah Cair", val(detailData.saranaPengelolaanLimbahCair)],
          ["Pemeliharaan Sarana Pengelolaan Limbah", val(detailData.pemiliharaanSaranaPengelolaanLimbah)],
          ["Jenis Tempat Pembuangan Air Tinja", val(detailData.jenisTempatPembuanganAirTinja)],
          ["Kepemilikan Kamar Mandi dan Jamban", val(detailData.kepemilikanKamarMandiDanJamban)],
          ["Jumlah Jamban", val(detailData.jumlahJamban)],
          ["Jenis Kloset", val(detailData.jenisKloset)],
          ["Jenis Tangki Septik", val(detailData.jenisTangkiSeptik)],
          ["Material Tangki Septik", val(detailData.materialTangkiSeptik)],
          ["Alas Tangki Septik", val(detailData.alasTangkiSeptik)],
          ["Lubang Penyedotan", val(detailData.lubangPenyedotan)],
          ["Posisi Tangki Septik", val(detailData.posisiTangkiSeptik)],
          ["Jarak Tangki Septik dengan Sumber Air", val(detailData.jarakTangkiSeptikDenganSumberAir)],
          ["Sumber Air Minum", val(detailData.sumberAirMinum)],
        ])}

        {renderSection("Skor & Status", "fa-clipboard-check", [
          ["Tanggal Pendataan", val(detailData.tanggalPendataan)],
          ["Nama Surveyor", detailData.Admin?.username || "-"],
          ["Skor", val(detailData.score)],
          ["Kategori", val(detailData.kategori)],
          ["Catatan", detailData.catatan || "Tidak ada catatan"],
          ["Status Validasi Bantuan", detailData.verifikasiBantuan || "Tidak ada status verifikasi bantuan"],
        ])}

        <h6 className="text-primary mb-2"><i className="fas fa-hand-holding-heart me-2"></i>Data Bantuan</h6>
        {detailData._loadingBantuan ? (
          <p className="text-muted">Memuat data bantuan...</p>
        ) : bantuanRows.length === 0 ? (
          <p className="text-muted"><em>Belum ada data bantuan terhubung.</em></p>
        ) : (
          <Table size="sm" bordered responsive className="align-middle mb-4">
            <tbody>
              {bantuanRows.map(([label, value], i) => (
                <tr key={i}>
                  <td className="text-muted label-cell">{label}</td>
                  <td>{value}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>Tutup</Button>
      </ModalFooter>
    </Modal>
  );
};

export default DetailInfoModal;
